<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-5">
   
    <div class="rounded bg-inexgrayo overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="text-white font-bold text-xl mb-2">Club</div>
        <h3 class="text-white text-base">
         {{club}}
        </h3>
        
      </div>
    </div>
     
    <div class="rounded bg-inexgrayo overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="text-white font-bold text-xl mb-2">Partidos</div>
        <p class="text-white text-base">
            {{ partidos }}
        </p>
      </div>
    </div>
   

   
    <div class="rounded bg-inexgrayo overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="text-white font-bold text-xl mb-2">Rendimiento</div>
        <p class="text-white text-base">
            {{rendimiento}}
        </p>
      </div>
    </div>
   
    <div class="rounded bg-inexgrayo overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="text-white font-bold text-xl mb-2">Total jugadores</div>
        <h4 class="text-white text-base">
         {{ total }}
        </h4>
      </div>
    </div>
    
  </div>
</div>
</template>

<script>
import Layout from '@/Shared/Layout'



export default {
  metaInfo: { title: 'Dashboard' },
  components: {
  },
  layout: Layout,
  props: {
    club: Number,
    partidos: Number,
    rendimiento: Number,
    total: Number,

  },
  mounted(){
  },
data () {
      return {
      }
    },
  }
</script>
<style>
  .small {
    max-width: 300px;
    margin:  10px auto;
  }
</style>